import { Component } from '@angular/core';
import { ForgotPasswordComponent } from './login-form/forgot-password/forgot-password.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { RouterModule, RouterOutlet, Routes } from '@angular/router';


@Component({
    selector: 'app-auth',
    imports: [RouterModule, RouterOutlet],
    providers: [],
    template: `<router-outlet></router-outlet>`
})
export class AuthComponent {
 
}
const routes :  Routes = [{
  path: '',
  children:[
    {path:'',component:LoginFormComponent },
    {path:'login',component:LoginFormComponent },
    {path:'forget-password',component:ForgotPasswordComponent}
  ]
}];
